import EventBus from '../services/service.eventBus';
import { fetchVin } from '../services/service.vehicle';
import { state as offerVehicleState } from '../store/store.offer-vehicle';

const onFetchVinByPlate = async (plateNumber: string, plateState: string): Promise<string> => {
  EventBus.publish('onFetchVinByPlate', { plateNumber, plateState });
  if (!plateNumber || !plateState) {
    return null;
  }

  try {
    const vin = await fetchVin(plateNumber, plateState);
    EventBus.publish('onFetchVinByPlateSuccess', vin);
    return vin;
  } catch (error) {
    EventBus.publish('onFetchVinByPlateFail', error);
    return null;
  }
};

const updateMileage = (mileage: number) => {
  offerVehicleState.mileage = mileage;
};

const actions = {
  onFetchVinByPlate,
  updateMileage,
};

export { actions };
export default actions;
